<svg
  xmlns="http://www.w3.org/2000/svg"
  width="11"
  height="20"
  viewBox="0 0 11 20"
  aria-labelledby="back-icon-title back-icon-desc"
  role="img"
>
  <title id="back-icon-title">Back icon</title>
  <desc id="back-icon-desc">This is a back icon.</desc>
  <path
    fill="#BA2F7D"
    fill-rule="evenodd"
    stroke="#BA2F7D"
    class="fill stroke"
    d="M2.176 10l7.681-8.12a.537.537 0 0 0 0-.73.469.469 0 0 0-.689 0L1.143 9.638a.534.534 0 0 0 0 .73l8.025 8.482c.19.201.499.201.69 0a.537.537 0 0 0 0-.73L2.175 10z"
  />
</svg>
